const Twitter = (): JSX.Element => (
  <g className="twitter-icon" fillRule="evenodd" style={{ fill: 'currentcolor' }}>
    <path
      d="M16,3.1c-0.6,0.2-1.3,0.5-1.9,0.5c0.6-0.5,1.2-1.1,1.4-1.9c-0.6,0.4-1.3,0.6-2.1,0.8c-0.5-0.5-1.2-0.9-1.9-1
    s-1.4,0-2.1,0.3C8.8,2.1,8.2,2.7,8,3.4C7.8,4.1,7.6,4.8,7.8,5.5C6.6,5.4,5.3,5.1,4.1,4.6C3,4,1.9,3.2,1.1,2.1
    c-0.3,0.5-0.5,1-0.5,1.6c0,1.1,0.6,2.1,1.5,2.7c-0.5,0-1-0.2-1.5-0.4v0.1c0,0.8,0.2,1.5,0.7,2c0.5,0.6,1.2,1,2,1.2
    c-0.5,0.2-1,0.2-1.5,0.1C2,10.1,2.4,10.7,3,11.1c0.5,0.4,1.2,0.6,1.9,0.6c-0.7,0.5-1.5,0.9-2.3,1.2c-0.9,0.2-1.7,0.3-2.6,0.2
    c1.5,0.9,3.2,1.5,5,1.5c6,0,9.3-5,9.3-9.3c0-0.2,0-0.3,0-0.4C15,4.3,15.5,3.7,16,3.1L16,3.1z"
    />
  </g>
);

export default Twitter;
